//useOnlineStatus.js
import { useState, useEffect, useRef } from "react";

const STABILITY_DELAY = 1500;

export async function waitForStableOnline(startedOffline = !navigator.onLine) {
  if (!startedOffline) {
    return;
  }

  while (!navigator.onLine) {
    await new Promise((resolve) => {
      const handleOnline = () => {
        window.removeEventListener("online", handleOnline);
        resolve();
      };

      window.addEventListener("online", handleOnline);
    });
  }

  while (true) {
    const stayedOnline = await new Promise((resolve) => {
      const timer = setTimeout(() => {
        cleanup();
        resolve(navigator.onLine);
      }, STABILITY_DELAY);

      const handleOffline = () => {
        clearTimeout(timer);
        cleanup();
        resolve(false);
      };

      const cleanup = () => {
        window.removeEventListener("offline", handleOffline);
      };

      window.addEventListener("offline", handleOffline);
    });

    if (stayedOnline) {
      return;
    }

    await new Promise((resolve) => {
      const handleOnline = () => {
        window.removeEventListener("online", handleOnline);
        resolve();
      };

      window.addEventListener("online", handleOnline);
    });
  }
}

export function useOnlineStatus() {
  // console.error("[useOnlineStatus] ⚠️ HOOK EXECUTING - THIS SHOULD DEFINITELY SHOW UP ⚠️");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isStablyOnline, setIsStablyOnline] = useState(navigator.onLine);
  const timerRef = useRef(null);

  useEffect(() => {
    const goOnline = () => {
      console.warn("[useOnlineStatus] Device came ONLINE (isOnline = true)");
      setIsOnline(true);
      // stable version waits to confirm connection is solid
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        if (navigator.onLine) {
          setIsStablyOnline(true);
        }
      }, STABILITY_DELAY);
    };

    const goOffline = () => {
      clearTimeout(timerRef.current);
      setIsOnline(false);
      setIsStablyOnline(false);
    };

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    console.warn("[useOnlineStatus] Event listeners attached to window");

    return () => {
      clearTimeout(timerRef.current);
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return { isOnline, isStablyOnline };
}
